const GreenRefresh = () => {
    return ( <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8571 1L13.0352 4.09076C11.8506 3.39741 10.4717 3 9 3C4.58172 3 1 6.58172 1 11C1 12.4571 1.38958 13.8233 2.07026 15M6.14286 21L4.96473 17.9092C6.14936 18.6026 7.52827 19 9 19C13.4183 19 17 15.4183 17 11C17 9.54285 16.6104 8.17669 15.9297 7" stroke="#2EC277" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg> );
}
 
export default GreenRefresh;